import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private _mobileNavOpen = signal(false);

  public mobileNavOpen = this._mobileNavOpen.asReadonly();  

  public toggleMobileSideMenu(): void {
    this._mobileNavOpen.set(!this._mobileNavOpen());
  }

  public closeMobileSideMenu(): void {  
    this._mobileNavOpen.set(false);
  }

  private _menuNavCollapsed = signal(false);

  public menuNavCollapsed = this._menuNavCollapsed.asReadonly(); 
  
  public setMenuNavCollapsed(value:boolean): void {

    this._menuNavCollapsed.set(value);
  }

} 